/* eslint-disable @typescript-eslint/no-explicit-any */

/** Mensagem de erro devolvida pela API (`message`/`error`/`detail`), com fallback amigável. */
export function getErrorMessage(error: any, fallback: string): string {
  const data = error?.response?.data;
  const detail = data?.message || data?.error || data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail) && detail.length) return detail.join(' ');
  return fallback;
}
